import { notification } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PermissionAccess from "../utils/permission";
import { NO_PERMISSION_MESSAGE } from "../utils/utils";

// import { ipValidation } from "../hooks/ipValidation";

export const usePermission = (module, type) => {

    const [permission, setPermission] = useState(false);
    const navigate = useNavigate();
    let Permission = PermissionAccess(module)

    useEffect(() => {
        if (Permission && Permission[type]) {
            setPermission(true);
        } else {
            setPermission(false);
            navigate("/dashboard", { replace: true });
            notification.destroy()
            notification["error"]({
                message: NO_PERMISSION_MESSAGE
            })
        }
    }, [Permission])
    return permission
};